<template>
  <div class="web-loader" @click="$emit('click', $event)">
    <div ref="spinner"></div>
  </div>
</template>

<script>

export default {
  props: {
    color: {
      type: String
    }
  },
  watch: {
    color (to) {
      this.setColor(to)
    }
  },
  methods: {
    setColor (to) {
      this.$refs.spinner.style.borderColor = to
    }
  },
  mounted () {
    this.setColor(this.color)
  }
}

</script>

<style lang="scss" scoped>

html {
  @keyframes Loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .web-loader {
    display: flex;
    align-items: center;
  }

  .web-loader > * {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border-width: 3px;
    border-style: solid;
    border-color: #004e9e;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    animation: Loader 1.2s linear infinite;
  }
}

</style>